import browser from '@openclassrooms/utils/browser';
import getPathName from './getPathName';

/**
 * Checks if the given path matches with the current path.
 * Set isExactMatch to true if you want to test the current path and given path are the same
 * @param path
 * @param isExactMatch
 * @returns {boolean}
 */
export default function isCurrentPath(path, isExactMatch = false) {
  const { pathname } = browser.window.location;
  const pathWithLang = getPathName(path);

  const pathRegex = isExactMatch ? `^${pathWithLang}$` : pathWithLang;

  return new RegExp(pathRegex).test(pathname);
}
